const userRoles = {
    admin: 'admin',
    teacher: 'teacher',
    guardian: 'guardian',
  }
  export default userRoles